<template>
  <h1>vipiska firmaho</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>
